import React, {Component} from 'react';
import {plainTranslate} from '../../common/translate';
import { connect } from 'react-redux';
import SettingsMenu from '../../sidebar/settings-menu';
import OpenSection from './../openSection.jsx';
import SingleCheckbox from './../singleCheckbox.jsx';
import Stages from './../stages.jsx';
import { fetchSettings} from "../../../actions/actions";
import { Skeleton } from 'antd';

class AccountSettingsPage extends Component {

    constructor(props) {
    super(props);
            this.state = {
            showMessage: false,
            ready: false
            };
        this.allSettings = [
            { value: "inventoryMeasures", name: 'Inventory measures', text: 'Select whether you need measures on each item line when creating new receipts for the Inventory'},
        ];
        this.updateStages = this.updateStages.bind(this);
    }

    componentDidMount() {
        this.props.getSettings('/' + this.props.match.params.db + '/api/account/settings/account-settings', 'accountSettings')
        .then(res => {            
            this.setState({ready: true})
        });
        if (this.props.title) {
            let titleArr = this.props.title;
            titleArr.map((item, key) => titleArr[key] = plainTranslate(this.props.settings.locale, item));
            document.title = titleArr.join(' ');
        }
    }
    
    updateStages() {
        this.props.getSettings('/' + this.props.match.params.db + '/api/account/settings/account-settings', 'accountSettings');
    }

     render() {
        return (
                <div>
                    <SettingsMenu
                       location = {this.props.location.pathname}
                       db = {this.props.match.params.db} />
                    <form name="settings_expense" className="cmxform form-horizontal bucket-form ng-pristine ng-valid">
                       <div className="row m-bot15">
                          <div className="col-lg-12">
                             <section className="panel">
                                <div className="panel-body">
                                   <div className="settings">
                                        <OpenSection
                                            label={plainTranslate(this.props.settings.locale, 'Account form type')}
                                            description={plainTranslate(this.props.settings.locale, "Specify different types of documents for accounts")}
                                            link={"/" + this.props.match.params.db + "/form-types-v2"}
                                         />
                                         <hr/>
                                        <SingleCheckbox
                                            value={this.props.settings.accountSettings}
                                            label={plainTranslate(this.props.settings.locale, 'Consent')}
                                            description={plainTranslate(this.props.settings.locale, 'This option enables you to record when, how and what type of consent you have received.')}
                                            settings={this.props.settings}
                                            type={'accountSettings'}
                                            saveRoute={'/' + this.props.match.params.db + '/api/account/save/settings/individual'}
                                            setting = {'dataConsent'}
                                        />
                                        <hr/>
                                        <OpenSection
                                            label={plainTranslate(this.props.settings.locale,'Data Retention')}
                                            description={plainTranslate(this.props.settings.locale,"You have the ability to set the time-limit for storing data by Composity software. The system will notify you for any account that is for deletion and add it in table Data retention exspired in module Accounts.")}
                                            component={'selectWithCheckbox'}
                                            value ={this.props.settings.accountSettings}
                                            type={'accountSettings'}
                                            saveRoute={'/' + this.props.match.params.db + '/api/account/save/settings/individual'}
                                            setting={'dataRetention'}
                                         />
                                         <hr/>
                                        <div className="col-sm-12 column-centered">
                                         {this.state.ready ?
                                           <Stages
                                                saveRoute={'/' + this.props.match.params.db + '/api/stages/save/settings/data'}
                                                type={'accountSettings'}
                                                workflow={"account"}
                                                configuration = {false}
                                                roles={'roles'}
                                                value={this.props.settings.accountSettings}
                                                settings={this.props.settings}
                                                fields={this.allSettings}
                                                setting = {'stages'}
                                                updateStages={this.updateStages}
                                            />
                                            :
                                            <Skeleton active />}
                                        </div>
                                   </div>
                                </div>
                             </section>
                          </div>
                       </div>
                    </form>
                </div>
                );
    }
}

const mapStateToProps = state => ({
    settings: state.settings,
});
const mapDispatchToProps = dispatch => ({
   getSettings: (path, type) =>
            dispatch(fetchSettings(path, type)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingsPage);
